import { useTranslation } from 'react-i18next';
import type { AdminPaymentItem } from '../types/adminPayment';
import { PaymentCopyableId } from './PaymentCopyableId';

interface PaymentTechnicalIdsSectionProps {
  payment: AdminPaymentItem;
}

export function PaymentTechnicalIdsSection({ payment }: PaymentTechnicalIdsSectionProps) {
  const { t } = useTranslation();

  return (
    <section
      className="rounded-lg border border-dashed border-border bg-muted/10 p-3 space-y-2 min-w-0"
      aria-labelledby="payment-technical-ids-heading"
    >
      <h3
        id="payment-technical-ids-heading"
        className="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
      >
        {t('payments.detail.technicalIds')}
      </h3>
      <PaymentCopyableId label={t('payments.identity.paymentId')} value={payment.payment_id} />
      <PaymentCopyableId
        label={t('payments.identity.subscriptionId')}
        value={payment.subscription_id}
      />
      <PaymentCopyableId label={t('payments.identity.tenantId')} value={payment.tenant_id} />
      <PaymentCopyableId
        label={t('payments.identity.providerPaymentId')}
        value={payment.provider_payment_id}
      />
      <PaymentCopyableId
        label={t('payments.identity.providerInvoiceId')}
        value={payment.provider_invoice_id}
      />
      <PaymentCopyableId
        label={t('payments.identity.paymentIntentId')}
        value={payment.payment_intent_id}
      />
    </section>
  );
}
